import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Stack,
} from '@mui/material';
import { APP_CONFIG } from '../../../../config/app.config';

interface DeleteWarehouseDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (options: {
    deleteConnections: boolean;
    deleteMutations: boolean;
  }) => void;
  warehouseName: string;
}

export const DeleteWarehouseDialog: React.FC<DeleteWarehouseDialogProps> = ({
  open,
  onClose,
  onConfirm,
  warehouseName,
}) => {
  const [deleteConnections, setDeleteConnections] = useState(false);
  const [deleteMutations, setDeleteMutations] = useState(false);
  const [confirmIrreversible, setConfirmIrreversible] = useState(false);

  const handleConfirm = () => {
    onConfirm({
      deleteConnections,
      deleteMutations,
    });
    handleClose();
  };

  const handleClose = () => {
    setDeleteConnections(false);
    setDeleteMutations(false);
    setConfirmIrreversible(false);
    onClose();
  };

  const isConfirmDisabled = !confirmIrreversible;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Warehouse</DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Typography>
            Are you sure you want to delete the warehouse "{warehouseName}"? This action cannot be undone.
          </Typography>

          <Stack spacing={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={deleteConnections}
                  onChange={(e) => setDeleteConnections(e.target.checked)}
                />
              }
              label="Delete all warehouse connections"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={deleteMutations}
                  onChange={(e) => setDeleteMutations(e.target.checked)}
                />
              }
              label="Delete all warehouse inventory mutations"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={confirmIrreversible}
                  onChange={(e) => setConfirmIrreversible(e.target.checked)}
                />
              }
              label="I'm aware that after deletion it is not possible to get this data back"
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ borderTop: `1px solid ${APP_CONFIG.ui.theme.colors.border}`, p: 2 }}>
        <Button onClick={handleClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isConfirmDisabled}
        >
          Delete Warehouse
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 